import { storage } from "@unimed/unijs/core";

export default JSON.parse(storage.getItem("state") || "{}");
